export interface MinutesSumBadgeProps {
  totalMinutes: number;
  /** The active company work-time fund (contract §C) for this entry's work_date — always passed by the caller, never hardcoded here. */
  expectedMinutes: number;
}

/**
 * uneto/fond live indicator (DAILY_ENTRY_INTERACTION_SPEC.md §8.3-8.5): green
 * check when entered minutes exactly match the company's standard available
 * minutes, amber (never red — incomplete is not an error) below or above,
 * with the explicit +/- difference always shown (never a bare "⚠" the user
 * has to do their own subtraction to interpret — the missing-time condition
 * must be immediately visible, same principle applied to Reports' daily
 * history table). The expected total comes from
 * `GET /company-performance-settings/current` (via the caller), never a
 * hardcoded literal — it currently equals 450 for Demo Firma, but is not
 * assumed to always be so.
 */
export function MinutesSumBadge({ totalMinutes, expectedMinutes }: MinutesSumBadgeProps) {
  const diff = totalMinutes - expectedMinutes;
  const tone = diff === 0 ? "nx-minutes-badge--ok" : "nx-minutes-badge--warn";

  return (
    <span className={`nx-minutes-badge ${tone}`} aria-live="polite">
      Uneto: <span className="tabular-nums">{totalMinutes}</span> / {expectedMinutes} min
      {diff === 0 ? " ✓" : diff > 0 ? ` ⚠ (+${diff})` : ` ⚠ Nedostaje ${-diff} min`}
    </span>
  );
}
